import { lazy, Suspense } from "react";

// Defers the TipTap editor (~840KB with prosemirror) into an async chunk —
// it's client-only, so the server renders the null fallback and the editor
// loads after hydration.
const NewsModalImpl = lazy(() => import("./NewsModal.impl"));

const NewsModal = (props) => (
  <Suspense fallback={null}>
    <NewsModalImpl {...props} />
  </Suspense>
);

export default NewsModal;
